export const APP_COLORS = {
    GRAY: '#363636',
    SPACE: '#263d42',
    YELLOW: '#CCA43B',
    LIGHT: '#E5E5E5',
    WHITE: '#FFFFFF',
}

export const PALETTE = [
    '#80ced7',
    '#63c7b2',
    '#8e6c88',
    '#263d42',
    '#577590',
    '#f3ca40',
    '#f2a541',
    '#d4d2a5',
    '#928779',
    '#3a445d',
    '#6a2e35',
    '#b6d094',
    '#c8553d',
    '#1b4079',
    '#7f9c96',
    '#b0413e',
    '#ffffc7',
    '#473335',
    '#5fad41',
    '#3a0842',
    '#F49097',
    '#DFB2F4',
    '#79ADDC',
    '#FCF5C7',
    '#CC978E',
    '#519872',
    '#3B5249',
    '#BEC5AD',
    '#C4D7F2',
    '#A39B8B',
    '#716A5C',
    '#0B5563',
    '#5E5C6C',
    '#F56960',
    '#D5B0AC',
    '#CEA0AE',
    '#F97068',
    '#E3D26F',
    '#2F1B25',
]

export const PALETTE2 = [
    '#F4CCCC', 
    '#FCE5CD', 
    '#FFF2CC', 
    '#D9EAD3', 
    '#D0E0E3', 
    '#C9DAF8', 
    '#CFE2F3', 
    '#D9D2E9', 
    '#EAD1DC', 
    '#F9D6C1', 
    '#FCE8B8', 
    '#FFF8B8', 
    '#E6E6E6', 
    '#CCCCCC', 
    '#B6D7A8', 
    '#A2C8D5', 
    '#A2B5D0', 
    '#8E7CC3', 
    '#C27BA0', 
    '#E06666', 
    '#F6B26B', 
    '#FFE699', 
    '#93C47D', 
    '#76A5AF', 
    '#6D9EEB', 
    '#7B64A3', 
    '#9E3C7E', 
    '#D7C5A5', 
    '#BABABA', 
    '#9BBB59', 
    '#2F75B5'
]


